// Customized DatePicker component

import { useRef } from 'react';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import './InputDate.scss';

export default function InputDate({
  name,
  value,
  onChange,
  minDate,
  maxDate,
  className,
  placeholder,
  error,
  small,
  disabled,
}) {
  const wrapRef = useRef(null);

  const handleOpenCalendar = (e) => {
    if (!wrapRef.current) return;
    // A focused, still empty field shows its inputs: a click there must
    // reach them, not toggle the calendar their focus has just opened
    if (e.target.closest('.react-calendar, .react-date-picker__inputGroup')) {
      return;
    }

    const calendarButton = wrapRef.current.querySelector(
      '.react-date-picker__calendar-button',
    );

    if (calendarButton) calendarButton.click();
  };

  return (
    <div
      className={
        'date-picker-wrap' +
        (className ? ' ' + className : '') +
        (value ? '' : ' placeholder pointer') +
        (error ? ' error' : '') +
        (small ? ' small' : '')
      }
      onClick={value ? undefined : handleOpenCalendar}
      ref={wrapRef}
    >
      <DatePicker
        name={name}
        monthAriaLabel={placeholder && `${placeholder} month`}
        dayAriaLabel={placeholder && `${placeholder} day`}
        yearAriaLabel={placeholder && `${placeholder} year`}
        calendarAriaLabel={placeholder && `${placeholder} calendar`}
        value={value}
        onChange={onChange}
        format='MMM d, y'
        clearIcon={null}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
      />
      <p className='placeholder-text'>{placeholder}</p>
      <p className={'error-msg' + (error ? ' visible' : '')}>{error}</p>
      <p className={'label' + (value ? ' visible' : '')}>{placeholder}</p>
    </div>
  );
}
